// โครงสร้างข้อมูล Package/Subscription สำหรับร้านค้า

/**
 * Package Types
 */
export const PACKAGE_TYPES = {
  FREE: 'free',
  BASIC: 'basic',
  PREMIUM: 'premium',
  ENTERPRISE: 'enterprise'
};

/**
 * Package Features
 */
export const PACKAGE_FEATURES = {
  // รูปภาพ
  MAX_COVER_IMAGES: 'maxCoverImages', // จำนวนรูปปกร้านสูงสุด
  MAX_PRODUCT_IMAGES: 'maxProductImages', // จำนวนรูปสินค้าต่อชิ้นสูงสุด
  
  // สินค้า
  MAX_ACTIVE_PRODUCTS: 'maxActiveProducts', // จำนวนสินค้าที่เปิดขายพร้อมกันสูงสุด
  
  // การชำระเงิน
  MAX_BANK_ACCOUNTS: 'maxBankAccounts', // จำนวนบัญชีธนาคารสูงสุด
  QR_CODE_ENABLED: 'qrCodeEnabled', // เปิดใช้งาน QR Code PromptPay (อัพโหลดรูป)
  QR_CODE_GENERATE: 'qrCodeGenerate', // Generate QR Code จาก PromptPay (แสดงยอดเงินอัตโนมัติ)
  MAX_QR_CODE_GENERATE: 'maxQRCodeGenerate', // จำนวน QR Code Generate สูงสุด
  
  // การจัดส่ง
  CASH_ON_DELIVERY: 'cashOnDelivery', // เก็บปลายทาง
  PICKUP_ENABLED: 'pickupEnabled', // นัดรับ
  
  // อื่นๆ
  PRIORITY_SUPPORT: 'prioritySupport', // สนับสนุนแบบ Priority
  ANALYTICS: 'analytics', // ระบบวิเคราะห์ข้อมูล
  CUSTOM_DOMAIN: 'customDomain', // โดเมนเฉพาะ
  SHIPPING_LABEL: 'shippingLabel', // พิมพ์ใบส่งของ
  PRINT_HISTORY: 'printHistory', // บันทึก history การพิมพ์ (เฉพาะ Premium/Enterprise)
  
  // Video Call Features
  VIDEO_CALL_ENABLED: 'videoCallEnabled', // เปิดใช้งาน Video Call
  VIDEO_CALL_LIMIT: 'videoCallLimit', // จำนวน calls/เดือน (-1 = ไม่จำกัด)
  VIDEO_CALL_DURATION: 'videoCallDuration', // ระยะเวลา/call (นาที)
  VIDEO_CALL_RECORDING: 'videoCallRecording', // บันทึก call
  VIDEO_CALL_SCREEN_SHARE: 'videoCallScreenShare', // Screen sharing
  
  // Caption Template Features
  CAPTION_TEMPLATES_COUNT: 'captionTemplatesCount', // จำนวน templates ที่ใช้ได้
  CAPTION_AI_ENABLED: 'captionAIEnabled', // ใช้ AI ช่วยเขียน
  CAPTION_CUSTOM_TEMPLATES: 'captionCustomTemplates' // สร้าง template เองได้
};

/**
 * Package Definitions
 */
export const PACKAGES = {
  [PACKAGE_TYPES.FREE]: {
    id: PACKAGE_TYPES.FREE,
    name: 'แพ็กเกจฟรี',
    price: 0,
    pricePerMonth: 0,
    features: {
      [PACKAGE_FEATURES.MAX_COVER_IMAGES]: 1,
      [PACKAGE_FEATURES.MAX_PRODUCT_IMAGES]: 3,
      [PACKAGE_FEATURES.MAX_ACTIVE_PRODUCTS]: 10,
      [PACKAGE_FEATURES.MAX_BANK_ACCOUNTS]: 1,
      [PACKAGE_FEATURES.QR_CODE_ENABLED]: false,
      [PACKAGE_FEATURES.QR_CODE_GENERATE]: false,
      [PACKAGE_FEATURES.MAX_QR_CODE_GENERATE]: 0,
      [PACKAGE_FEATURES.CASH_ON_DELIVERY]: false,
      [PACKAGE_FEATURES.PICKUP_ENABLED]: true,
      [PACKAGE_FEATURES.PRIORITY_SUPPORT]: false,
      [PACKAGE_FEATURES.ANALYTICS]: false,
      [PACKAGE_FEATURES.CUSTOM_DOMAIN]: false,
      [PACKAGE_FEATURES.SHIPPING_LABEL]: false,
      [PACKAGE_FEATURES.PRINT_HISTORY]: false,
      [PACKAGE_FEATURES.VIDEO_CALL_ENABLED]: false,
      [PACKAGE_FEATURES.VIDEO_CALL_LIMIT]: 0,
      [PACKAGE_FEATURES.VIDEO_CALL_DURATION]: 0,
      [PACKAGE_FEATURES.VIDEO_CALL_RECORDING]: false,
      [PACKAGE_FEATURES.VIDEO_CALL_SCREEN_SHARE]: false,
      [PACKAGE_FEATURES.CAPTION_TEMPLATES_COUNT]: 1, // Basic template เท่านั้น
      [PACKAGE_FEATURES.CAPTION_AI_ENABLED]: false,
      [PACKAGE_FEATURES.CAPTION_CUSTOM_TEMPLATES]: false
    },
    description: 'แพ็กเกจเริ่มต้นสำหรับร้านค้าใหม่'
  },
  
  [PACKAGE_TYPES.BASIC]: {
    id: PACKAGE_TYPES.BASIC,
    name: 'แพ็กเกจพื้นฐาน',
    price: 299,
    pricePerMonth: 299,
    features: {
      [PACKAGE_FEATURES.MAX_COVER_IMAGES]: 3,
      [PACKAGE_FEATURES.MAX_PRODUCT_IMAGES]: 5,
      [PACKAGE_FEATURES.MAX_ACTIVE_PRODUCTS]: 50,
      [PACKAGE_FEATURES.MAX_BANK_ACCOUNTS]: 2,
      [PACKAGE_FEATURES.QR_CODE_ENABLED]: true,
      [PACKAGE_FEATURES.QR_CODE_GENERATE]: false,
      [PACKAGE_FEATURES.MAX_QR_CODE_GENERATE]: 0,
      [PACKAGE_FEATURES.CASH_ON_DELIVERY]: false,
      [PACKAGE_FEATURES.PICKUP_ENABLED]: true,
      [PACKAGE_FEATURES.PRIORITY_SUPPORT]: false,
      [PACKAGE_FEATURES.ANALYTICS]: true,
      [PACKAGE_FEATURES.CUSTOM_DOMAIN]: false,
      [PACKAGE_FEATURES.ADMIN_MIDDLEMAN]: false,
      [PACKAGE_FEATURES.SHIPPING_LABEL]: true,
      [PACKAGE_FEATURES.PRINT_HISTORY]: false,
      [PACKAGE_FEATURES.VIDEO_CALL_ENABLED]: false,
      [PACKAGE_FEATURES.VIDEO_CALL_LIMIT]: 0,
      [PACKAGE_FEATURES.VIDEO_CALL_DURATION]: 0,
      [PACKAGE_FEATURES.VIDEO_CALL_RECORDING]: false,
      [PACKAGE_FEATURES.VIDEO_CALL_SCREEN_SHARE]: false,
      [PACKAGE_FEATURES.CAPTION_TEMPLATES_COUNT]: 3, // Basic, Professional, Casual
      [PACKAGE_FEATURES.CAPTION_AI_ENABLED]: true,
      [PACKAGE_FEATURES.CAPTION_CUSTOM_TEMPLATES]: false
    },
    description: 'เหมาะสำหรับร้านค้าขนาดเล็ก-กลาง'
  },
  
  [PACKAGE_TYPES.PREMIUM]: {
    id: PACKAGE_TYPES.PREMIUM,
    name: 'แพ็กเกจพรีเมียม',
    price: 799,
    pricePerMonth: 799,
    features: {
      [PACKAGE_FEATURES.MAX_COVER_IMAGES]: 10,
      [PACKAGE_FEATURES.MAX_PRODUCT_IMAGES]: 10,
      [PACKAGE_FEATURES.MAX_ACTIVE_PRODUCTS]: 200,
      [PACKAGE_FEATURES.MAX_BANK_ACCOUNTS]: 5,
      [PACKAGE_FEATURES.QR_CODE_ENABLED]: true,
      [PACKAGE_FEATURES.QR_CODE_GENERATE]: true,
      [PACKAGE_FEATURES.MAX_QR_CODE_GENERATE]: 3,
      [PACKAGE_FEATURES.CASH_ON_DELIVERY]: true,
      [PACKAGE_FEATURES.PICKUP_ENABLED]: true,
      [PACKAGE_FEATURES.PRIORITY_SUPPORT]: true,
      [PACKAGE_FEATURES.ANALYTICS]: true,
      [PACKAGE_FEATURES.CUSTOM_DOMAIN]: false,
      [PACKAGE_FEATURES.ADMIN_MIDDLEMAN]: true,
      [PACKAGE_FEATURES.SHIPPING_LABEL]: true,
      [PACKAGE_FEATURES.PRINT_HISTORY]: true,
      [PACKAGE_FEATURES.VIDEO_CALL_ENABLED]: true,
      [PACKAGE_FEATURES.VIDEO_CALL_LIMIT]: 20, // 20 calls/เดือน
      [PACKAGE_FEATURES.VIDEO_CALL_DURATION]: 20, // 20 นาที/call
      [PACKAGE_FEATURES.VIDEO_CALL_RECORDING]: false,
      [PACKAGE_FEATURES.VIDEO_CALL_SCREEN_SHARE]: true,
      [PACKAGE_FEATURES.CAPTION_TEMPLATES_COUNT]: 5, // Basic, Professional, Casual, Urgent, Seasonal
      [PACKAGE_FEATURES.CAPTION_AI_ENABLED]: true,
      [PACKAGE_FEATURES.CAPTION_CUSTOM_TEMPLATES]: false
    },
    description: 'เหมาะสำหรับร้านค้าขนาดใหญ่'
  },
  
  [PACKAGE_TYPES.ENTERPRISE]: {
    id: PACKAGE_TYPES.ENTERPRISE,
    name: 'แพ็กเกจองค์กร',
    price: 1999,
    pricePerMonth: 1999,
    features: {
      [PACKAGE_FEATURES.MAX_COVER_IMAGES]: -1, // ไม่จำกัด
      [PACKAGE_FEATURES.MAX_PRODUCT_IMAGES]: -1, // ไม่จำกัด
      [PACKAGE_FEATURES.MAX_ACTIVE_PRODUCTS]: -1, // ไม่จำกัด
      [PACKAGE_FEATURES.MAX_BANK_ACCOUNTS]: -1, // ไม่จำกัด
      [PACKAGE_FEATURES.QR_CODE_ENABLED]: true,
      [PACKAGE_FEATURES.QR_CODE_GENERATE]: true,
      [PACKAGE_FEATURES.MAX_QR_CODE_GENERATE]: -1, // ไม่จำกัด
      [PACKAGE_FEATURES.CASH_ON_DELIVERY]: true,
      [PACKAGE_FEATURES.PICKUP_ENABLED]: true,
      [PACKAGE_FEATURES.PRIORITY_SUPPORT]: true,
      [PACKAGE_FEATURES.ANALYTICS]: true,
      [PACKAGE_FEATURES.CUSTOM_DOMAIN]: true,
      [PACKAGE_FEATURES.ADMIN_MIDDLEMAN]: true,
      [PACKAGE_FEATURES.SHIPPING_LABEL]: true,
      [PACKAGE_FEATURES.PRINT_HISTORY]: true,
      [PACKAGE_FEATURES.VIDEO_CALL_ENABLED]: true,
      [PACKAGE_FEATURES.VIDEO_CALL_LIMIT]: -1, // ไม่จำกัด
      [PACKAGE_FEATURES.VIDEO_CALL_DURATION]: 30, // 30 นาที/call
      [PACKAGE_FEATURES.VIDEO_CALL_RECORDING]: true,
      [PACKAGE_FEATURES.VIDEO_CALL_SCREEN_SHARE]: true,
      [PACKAGE_FEATURES.CAPTION_TEMPLATES_COUNT]: 10, // ทั้งหมด + Custom Templates
      [PACKAGE_FEATURES.CAPTION_AI_ENABLED]: true,
      [PACKAGE_FEATURES.CAPTION_CUSTOM_TEMPLATES]: true // สร้าง template เองได้
    },
    description: 'เหมาะสำหรับองค์กรและธุรกิจขนาดใหญ่'
  }
};

/**
 * Create Package Subscription Model
 */
export const createPackageSubscriptionModel = (data) => {
  return {
    storeId: data.storeId || '',
    packageType: data.packageType || PACKAGE_TYPES.FREE,
    status: data.status || 'active', // active, expired, cancelled
    startDate: data.startDate || new Date(),
    endDate: data.endDate || null, // null = unlimited
    autoRenew: data.autoRenew || false,
    paymentMethod: data.paymentMethod || '', // bank, credit_card, etc.
    transactionId: data.transactionId || '',
    createdAt: data.createdAt || new Date(),
    updatedAt: new Date()
  };
};

/**
 * Get Package Features
 */
export const getPackageFeatures = (packageType) => {
  return PACKAGES[packageType]?.features || PACKAGES[PACKAGE_TYPES.FREE].features;
};

/**
 * Check if feature is enabled
 * @param {string} packageType - Package type
 * @param {string} feature - Feature key
 * @param {object} subscription - Optional subscription object for expiration check
 * @returns {boolean} true if feature is enabled and package is valid
 */
export const isFeatureEnabled = (packageType, feature, subscription = null) => {
  // ตรวจสอบ expiration ถ้ามี subscription
  if (subscription) {
    try {
      const { isPackageValid } = require('../utils/packageExpirationUtils');
      if (!isPackageValid(subscription)) {
        return false; // Package หมดอายุ
      }
    } catch (error) {
      console.warn('Error checking package expiration:', error);
    }
  }
  
  const features = getPackageFeatures(packageType);
  return features[feature] === true || features[feature] > 0 || features[feature] === -1;
};

/**
 * Get feature limit
 */
export const getFeatureLimit = (packageType, feature) => {
  const features = getPackageFeatures(packageType);
  return features[feature] || 0;
};

/**
 * Check if limit is unlimited
 */
export const isUnlimited = (limit) => {
  return limit === -1;
};

